import * as React from 'react'
const SvgComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      fill="currentColor"
      d="M12 16a.968.968 0 0 1-.713-.288A.964.964 0 0 1 11 15V4.825l-.9.9A.933.933 0 0 1 9.412 6a.97.97 0 0 1-.712-.3 1.02 1.02 0 0 1-.275-.713A.93.93 0 0 1 8.7 4.3l2.6-2.6a1.035 1.035 0 0 1 1.4 0l2.6 2.6c.2.2.3.442.3.725s-.1.517-.3.7a1.02 1.02 0 0 1-.713.275.93.93 0 0 1-.687-.275l-.9-.9V15a.968.968 0 0 1-.288.713A.964.964 0 0 1 12 16Zm-6 7c-.55 0-1.021-.196-1.413-.588A1.922 1.922 0 0 1 4 21V10c0-.55.196-1.021.588-1.413A1.922 1.922 0 0 1 6 8h2c.283 0 .521.096.713.288.192.192.288.43.287.712a.968.968 0 0 1-.288.713A.964.964 0 0 1 8 10H6v11h12V10h-2a.968.968 0 0 1-.713-.288A.964.964 0 0 1 15 9c0-.283.096-.521.288-.713A.964.964 0 0 1 16 8h2c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v11c0 .55-.196 1.021-.588 1.413A1.922 1.922 0 0 1 18 23H6Z"
    />
  </svg>
)
export default SvgComponent
